import { State } from 'src/redux/reducer';
import { isLoaded, isPending, shouldLoad } from 'src/redux/utils';

export const oneModelsSelector = (state: State) => state.oneModels.entities;
export const oneModelsStatusSelector = (state: State) => state.oneModels.status;
export const oneModelsLoadedSelector = isLoaded(oneModelsStatusSelector);
export const oneModelsPendingSelector = isPending(oneModelsStatusSelector);
export const shouldOneModelsSelector = shouldLoad(oneModelsStatusSelector);
